<template>
  <b-modal id="device-selector-modal" title="Select Device" hide-footer>
    <b-breadcrumb class="mb-3">
      <b-breadcrumb-item :active="page === 'type'" @click="resetDeviceType">
        {{ selectedDeviceType ? selectedDeviceType.name : 'Device Type' }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="selectedDeviceType"
        :active="page === 'manufacturer'"
        @click="resetManufacturer"
      >
        {{ selectedManufacturer ? selectedManufacturer.name : 'Manufacturer' }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="selectedManufacturer"
        :active="page === 'device'"
      >
        Device
      </b-breadcrumb-item>
    </b-breadcrumb>
    <div class="device-selector__panels">
      <div v-show="page === 'devicetype'">
        <b-form-input v-model="deviceTypeQuery" placeholder="Search" />
        <br />
        <b-spinner v-if="deviceTypesLoading" />
        <b-list-group>
          <b-list-group-item
            v-for="deviceType in queriedDeviceTypes"
            :key="`device-type-${deviceType.id}`"
            @click="
              selectedDeviceType = deviceType;
              page = 'manufacturer';
            "
          >
            {{ deviceType.name }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <div v-show="page === 'manufacturer'">
        <b-form-input v-model="manufacturerQuery" placeholder="Search" />
        <br />
        <b-spinner v-if="manufacturersLoading" />
        <b-list-group>
          <b-list-group-item
            v-for="manufacturer in queriedManufacturers"
            :key="`manufacturer-${manufacturer.id}`"
            @click="
              selectedManufacturer = manufacturer;
              page = 'device';
            "
          >
            <b-img-lazy
              thumbnail
              height="50px"
              width="50px"
              :src="
                `https://res.cloudinary.com/gokaizen/image/upload/w_100,h_100,c_fit/kzcdn/${manufacturer.thumbnail}`
              "
            />
            {{ manufacturer.name }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <div v-show="page === 'device'">
        <b-form-input v-model="deviceQuery" placeholder="Search" />
        <br />
        <b-spinner v-if="devicesLoading" />
        <b-list-group>
          <b-list-group-item
            v-for="device in queriedDevices"
            :key="`device-${device.id}`"
            @click="selectDevice(device)"
          >
            <b-img-lazy
              v-if="device.thumbnail"
              thumbnail
              height="50px"
              width="50px"
              :src="
                `https://res.cloudinary.com/gokaizen/image/upload/w_100,h_100,c_fit/kzcdn/${device.thumbnail}`
              "
            />
            {{ device.name }}
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </b-modal>
</template>
<script>
import EventBus from '@/services/bus';

import { mapState, mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {
      selectedDeviceId: this.value,
      selectedDeviceType: null,
      deviceTypeQuery: '',
      selectedManufacturer: null,
      manufacturerQuery: '',
      deviceQuery: '',
      page: 'devicetype',
      targetBusId: null,
    };
  },
  computed: {
    ...mapState('devicetypes', {
      deviceTypes: 'list',
      deviceTypesLoading: 'loading',
    }),
    ...mapGetters('devicetypes', {
      getDeviceType: 'getDeviceType',
    }),
    ...mapState('manufacturers', {
      manufacturers: 'list',
      manufacturersLoading: 'loading',
    }),
    ...mapGetters('manufacturers', {
      getManufacturer: 'getManufacturer',
    }),
    ...mapState('devices', {
      devices: 'list',
      devicesLoading: 'loading',
    }),
    ...mapGetters('devices', {
      deviceById: 'getDevice',
      filteredDevices: 'getTypeManufacturerDevices',
    }),
    selectedDevice() {
      return this.deviceById(this.value);
    },
    loading() {
      return (
        this.deviceTypesLoading ||
        this.manufacturersLoading ||
        this.devicesLoading
      );
    },
    queriedDeviceTypes() {
      return this.deviceTypes.filter((deviceType) => {
        return deviceType.name
          .toLowerCase()
          .includes(this.deviceTypeQuery.toLowerCase());
      });
    },
    queriedManufacturers() {
      return this.manufacturers.filter((manufacturer) => {
        return manufacturer.name
          .toLowerCase()
          .includes(this.manufacturerQuery.toLowerCase());
      });
    },
    queriedDevices() {
      let { devices } = this;
      if (this.selectedManufacturer && this.selectedDeviceType) {
        devices = this.filteredDevices(
          this.selectedDeviceType.id,
          this.selectedManufacturer.id,
        );
      }
      return devices.filter((device) => {
        return device.name
          .toLowerCase()
          .includes(this.deviceQuery.toLowerCase());
      });
    },
  },
  mounted() {
    EventBus.$on('open-device-selector-modal', ([busId, currentDeviceId]) => {
      this.targetBusId = busId;
      this.loadInitialDevice(currentDeviceId);
      this.openModal();
    });
    this.$store.dispatch('devicetypes/ensure');
    this.$store.dispatch('manufacturers/ensure');
    this.$store.dispatch('devices/ensure');
  },
  methods: {
    selectDevice(device) {
      if (this.targetBusId) {
        EventBus.$emit(
          `device-selector-modal-select-${this.targetBusId}`,
          device.id,
        );
      }
      this.selectedDeviceId = device.id;
      this.$bvModal.hide('device-selector-modal');
    },
    openModal() {
      this.$bvModal.show('device-selector-modal');
    },
    resetDeviceType() {
      this.selectedDeviceType = null;
      this.selectedManufacturer = null;
      this.selectedDeviceId = null;
      this.page = 'devicetype';
    },
    resetManufacturer() {
      this.selectedManufacturer = null;
      this.selectedDeviceId = null;
      this.page = 'manufacturer';
    },
    resetDevice() {
      this.selectedDeviceId = null;
      this.$emit('input', null);
    },
    loadInitialDevice(deviceId) {
      this.selectedDeviceId = deviceId;
      if (!deviceId) {
        this.page = 'devicetype';
        return;
      }
      const device = this.$store.getters['devices/getDevice'](deviceId);
      if (device) {
        this.selectedManufacturer = this.$store.getters[
          'manufacturers/getManufacturer'
        ](device.manufacturer_id);
        this.selectedDeviceType = this.$store.getters[
          'devicetypes/getDeviceType'
        ](device.type_id);
        this.page = 'device';
      }
    },
  },
};
</script>
<style scoped>
.device-selector__panels .list-group {
  max-height: calc(100vh - 1.75rem - 1.75rem - 220px);
  overflow-y: auto;
}
.device-selector__panels .list-group-item {
  cursor: pointer;
}
</style>
